import WithAuth from "../components/hoc/with-auth.tsx"
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx/index.tsx"
import { Flex, Text, Box, Skeleton } from "@chakra-ui/react"
import FrequentTradesPage from "../components/pages/frequent-trades-page.tsx"
import CreateTransactionsForm from "../components/pages/create-transactions-form.tsx"
import CreateUserForm from "../components/pages/create-user-form.tsx"
import { useQuery } from "react-query"
import { getAllGroups } from "../services/crm.service.ts"
import _ from "lodash"
import ErrorBoundary from "../components/ErrorBoundary.tsx"
import ChangePasswordForm from "../components/pages/change-password-form.tsx"
import ChangeUserGroupForm from "../components/pages/change-user-group-form.tsx"

const ChangeUserGroup = () => {
  const {
    data,
    isLoading,
    isError,
    isRefetching,
    isFetched,
    isFetchedAfterMount,
    refetch,
  } = useQuery(["all-groups"], () => getAllGroups(), {})

  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Change User Group"
          pageDesc="Change user group"
        >
          <ErrorBoundary>
            {isLoading ? (
              <Skeleton minHeight="500px" width="100%" />
            ) : (
              <>
                <ChangeUserGroupForm
                  //@ts-ignore
                  groups={_.isEmpty(data?.data?.data) ? [] : data?.data?.data}
                />
              </>
            )}
          </ErrorBoundary>
        </LayoutWithSidebar>
      </WithAuth>
    </>
  )
}

export default ChangeUserGroup
